<div class="header container" color="primary">
  <div class="logo" (click)="backToHome()">
    <img [src]="'HOME.HEADER.IMAGE' | translate" alt="logo" routerLink="/" />
     <p>{{ 'HOME.HEADER.NAME' | translate }}</p>
  </div>

  <div class="container-user">
    <mat-form-field
      [matTooltip]="'TOOLTIPS.CHANGE_LANGUAGE' | translate"
      data-fs-element="Header-Select-Language"
      class="language"
      [ngClass]="{ 'select-opened': langSelect.panelOpen }"
    >
      <mat-select
        #langSelect="matSelect"
        [value]="languageCode"
        (selectionChange)="changeLanguage($event.value)"
      >
        <mat-select-trigger>
          {{ multiLangService.getLangName(languageCode) }}
        </mat-select-trigger>

        @for (lang of multiLangService.getLanguages(); track lang) {
        <mat-option
          [attr.data-fs-element]="'Header-Option-Language-' + lang"
          class="select-language"
          [value]="lang"
        >
          {{ multiLangService.getLangName(lang) }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (user()?.photo) {
    <img class="avatar" [src]="user()?.photo" alt="Photo user" />
    } @if (!user()?.photo) {
    <div class="avatar initials-avatar">
      {{ initials }}
    </div>
    }
  </div>
</div>
